module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-11.7279995d.jpg";